const booking = {
    familyRules: {
        title: 'Regels voor Gezinsreizen',
        maxTwoAdults: 'Maximaal 2 volwassenen (vanaf 16 jaar) zijn toegestaan',
        moreThanTwoAdultsAdvice: 'Als je meer dan 2 volwassenen hebt, raden we aan om aparte boekingen te maken',
        atLeastOneAdult: 'Ten minste één volwassene (vanaf 18 jaar) moet aanwezig zijn op de reis'
    },
    // CTA on TripDetailsPage before opening the booking form
    startBooking: 'Start Boeking',
    startBookingDescription: 'Selecteer datums, aantal deelnemers en voer details in',
    // Steps
    stepQuotes: 'Selecteer Quotes',
    stepParticipants: 'Deelnemersinformatie',
    stepAddress: 'Contactgegevens',
    stepReview: 'Controleer Boeking',
    stepPackage: 'Selecteer pakket',

    // Quotes Selection
    selectQuotes: 'Selecteer het aantal quotes',
    selectQuotesDescription: 'Kies hoeveel personen deelnemen aan de reis (van 1 tot 30)',
    selectPackageTitle: 'Selecteer pakket',
    selectPackageSubtitle: 'Kies het type deelname op basis van het aantal deelnemers',
    numberOfQuotes: 'Aantal quotes',
    pricePerQuote: 'Prijs per quote',
    pricePerPerson: 'Prijs per persoon',
    depositPerPersonLabel: 'Aanbetaling per persoon',
    totalAmount: 'Totaalbedrag',
    depositAmount: 'Aanbetaling',
    balanceAmount: 'Saldo',
    insufficientSpotsForPackage: 'Niet beschikbaar: {required} plaatsen nodig maar slechts {available} over',
    family: 'Gezin',
    people: 'Personen',

    // Participants
    participantsInfo: 'Deelnemersinformatie',
    participantsDescription: 'Voer voor- en achternaam in van alle deelnemers',
    participant: 'Deelnemer',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    age: 'Leeftijd',
    child: 'Kind',
    adult: 'Volwassene',

    // Address
    contactInfo: 'Contactgegevens',
    contactDescription: 'Voer je adres in voor facturering',
    address: 'Adres',
    city: 'Stad',
    postalCode: 'Postcode',
    country: 'Land',
    phone: 'Telefoon',

    // Review
    reviewBooking: 'Controleer Boeking',
    reviewDescription: 'Controleer alle details voordat je doorgaat naar betaling',
    tripDetails: 'Reisdetails',
    participants: 'Deelnemers',
    paymentSummary: 'Betalingssamenvatting',

    // Navigation
    previous: 'Vorige',
    next: 'Volgende',
    cancel: 'Annuleren',
    proceedToPayment: 'Ga Door naar Betaling',
    processing: 'Verwerken...',

    // Validation
    validationError: 'Vul alle verplichte velden in',
    createError: 'Fout bij het maken van de boeking. Probeer opnieuw.',
    alreadyBookedError: 'Je hebt al een boeking voor deze reis. Je kunt slechts één reis per gebruiker boeken.',

    // Date Selection
    selectDate: 'Selecteer Datum',
    selectTripDate: 'Selecteer de reisdatum',
    selectDateDescription: 'Kies uit beschikbare datums voor',
    noDatesAvailable: 'Geen datums beschikbaar voor deze reis',
    datesComingSoon: 'De datums voor deze reis worden binnenkort bekendgemaakt!',
    followSocialForUpdates: 'Volg ons op sociale media voor updates',
    spotsAvailable: 'plaatsen beschikbaar',
    spotsTotal: 'van',
    spotsTotalLabel: 'totaal',
    fullyBooked: 'Vol',
    spotsRemaining: 'plaatsen over',

    // Address info
    addressSavedInfo: 'Je opgeslagen adresgegevens worden gebruikt. Je kunt ze hieronder wijzigen.',
    addressWillBeSaved: 'Deze adresgegevens worden opgeslagen in je account voor toekomstige boekingen.',

    // Footer note
    childrenDefinition: '* met kind bedoelen we onder de 16 jaar.',

    // Country options
    countryOther: 'Anders',

    // Discount Code
    discountCode: {
        title: 'Kortingscode',
        enterCode: 'Voer kortingscode in',
        placeholder: 'Voer kortingscode in',
        apply: 'Toepassen',
        validating: 'Valideren...',
        applied: 'Code toegepast',
        appliedMessage: 'Kortingscode toegepast! {percent}% korting',
        invalid: 'Ongeldige kortingscode',
        validationError: 'Fout bij het valideren van de kortingscode',
        removed: 'Kortingscode verwijderd',
        selectDateFirst: 'Selecteer eerst een reisdatum',
        enterCodeError: 'Voer een kortingscode in',
    },

    // Trip Types
    tripTypes: {
        solo: 'Solo Reis',
        duo: 'Duo Reis',
        trio: 'Gezin - 3 Personen',
        pocker: 'Gezin - 4 Personen',
    },

    // Trip Descriptions
    tripDescriptions: {
        solo: 'Enkele reis',
        duo: 'Koppelreis',
        trio: 'Gezinsreis (2 volwassenen + 1 kind*)',
        pocker: 'Gezinsreis (2 volwassenen + 2 kinderen*)',
    },

    // Review Step Labels
    selectedDate: 'Geselecteerde datum',
    dateLabel: 'Datum',
    participantNumber: 'Deelnemer',
    nameLabel: 'Voornaam',
    lastNameLabel: 'Achternaam',
    ageLabel: 'Leeftijd',
    yearsOld: 'jaar',
    addressLabel: 'Adres',
    cityLabel: 'Stad',
    postalCodeLabel: 'Postcode',
    countryLabel: 'Land',
    phoneLabel: 'Telefoon',
    originalPrice: 'Originele prijs',
    discount: 'Korting',
    remove: 'Verwijderen',

    // Errors
    error: {
        loadingDates: 'Fout bij het laden van beschikbare datums',
        noDatesAvailable: 'Geen datums beschikbaar voor deze reis',
        loadingTripConfig: 'Fout bij het laden van reisconfiguratie',
        selectDateForTrip: 'Selecteer een datum voor de reis',
        noPriceAvailable: 'Geen prijs beschikbaar voor deze reis',
    },

    // Validation Messages
    validation: {
        atLeastOneAdult18: 'Ten minste één deelnemer moet 18 jaar of ouder zijn',
        familyTripNeedsChild: 'Voor gezinsreizen (3-4 personen) is ten minste één kind onder de 16 jaar vereist',
        familyTripMaxAdults: 'Voor gezinsreizen (3-4 personen) zijn maximaal 2 volwassenen (16+ jaar) toegestaan. Je hebt {count} volwassenen ingevoerd.',
        fillAllParticipantFields: 'Vul alle verplichte velden voor deelnemers in',
        fillAllAddressFields: 'Vul alle verplichte adresvelden in',
        selectDateToContinue: 'Selecteer een datum om door te gaan',
        selectParticipationType: 'Selecteer een deelnametype om door te gaan',
    },
};

export default booking;

